import React from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import { footerTrackings } from '@xingternal/platform-layout-trackings/src/footer';
import { getTrackingUrlHOF } from '@xingternal/xing-tracking';

import { Button } from '@xingternal/button';
import { Logo } from '@xingternal/platform-layout-logo';
import { CenterContainer } from '@xingternal/platform-layout-view-wrapper';

import { propTypes } from './footer-prop-types';
import { formatItems } from './formatItems';
import { LinkList } from './LinkList';
import { Accordion } from './Accordion';
import styles from './Footer.css';

const getTrackingURL = getTrackingUrlHOF(footerTrackings);

const Footer = ({ links, loggedIn, intl, homeLink }) => {
  const footerLinks = formatItems(intl, links);

  return (
    <div className={cx(styles.footer, { [styles.footerLoggedOut]: !loggedIn })}>
      <Accordion
        key="accordion"
        initiallyOpen={0}
        className={styles.accordionContainer}
        items={footerLinks}
      />
      <CenterContainer className={styles.container}>
        <ul className={styles.links}>
          {footerLinks.map((item, i) => (
            <li
              key={i}
              className={cx(styles.linkGroup, {
                [styles.wide]: footerLinks.length - 1 === i && loggedIn,
              })}
            >
              {item.header}
              {item.content}
            </li>
          ))}
        </ul>
        <div className={styles.bottomList}>
          <div className={styles.branding}>
            <Logo
              className={styles.logo}
              dataQa="logo"
              homeLink={homeLink}
              variant="duo"
            />

            <div className={styles.brandingLink}>
              <FormattedMessage
                id="MALT_FOOTER_COPYRIGHT_API"
                values={{
                  siteoperator: intl.formatMessage({
                    id: 'VERTICAL_NAVIGATION_FOOTER_NEWWORKSE',
                  }),
                }}
              />
            </div>
          </div>
          {/* TODO: add legal footer here */}
          <div className={styles.legalLinks}>
            <LinkList className={styles.bottom} data={links.legalLinks} />
            <div className={cx(styles.item, styles.itemLast)}>
              <p className={styles.langLink}>
                <FormattedMessage id={'FOOTER_LANGUAGES'} />{' '}
              </p>
              <Button
                size="small"
                variant="tertiary"
                href={getTrackingURL({
                  to: loggedIn ? '/settings/account/language' : '/language',
                  trackingKey: 'languageSwitchFooter',
                })}
              >
                <FormattedMessage id={'ACTIVE_LANGUAGE'} />
              </Button>
            </div>
          </div>
        </div>
      </CenterContainer>
    </div>
  );
};

Footer.propTypes = propTypes;

export { Footer };
